export const EMPTY_ARRAY_10 = [...Array(10)];
export const EMPTY_ARRAY_4 = [...Array(4)];
export const EMPTY_ARRAY_3 = [...Array(3)];
export const EMPTY_ARRAY_2 = [...Array(2)];
export const EMPTY_ARRAY_1 = [...Array(1)];
